import type { SceneModule } from '../_shared/types'
import VsComparison from './VsComparison'
import { VsComparisonEditor } from './Editor'
import { render } from './svgRender'
import { VsComparisonComposition } from './Composition'

export const module: SceneModule = {
  id: 'vs-comparison',
  Component: VsComparison,
  Composition: VsComparisonComposition,
  Editor: VsComparisonEditor,
  svgRender: render,
}
